function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import { IconCheck, IconChevron } from "../Icons";
import classnames from 'classnames';
import FormError from "../FormError";
import FormHint from "../FormHint";
import handleEvent from "../libs/handleEvent";
import injectStyles from "../jss";
import styles from "./Checkbox.jss.js";
import Tooltip from "../Tooltip";
import AnimateHeight from 'react-animate-height';
export var Checkbox = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Checkbox, _React$PureComponent);

  function Checkbox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      focused: false,
      labelHeight: 0,
      isLabelOpen: false,
      labelRef: React.createRef(),
      isScrolledToBottom: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (event) {
      var _this$props = _this.props,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          value = _this$props.value,
          name = _this$props.name;
      handleEvent(name, onFocus, event);
      handleEvent(name, onChange, value, event);
      handleEvent(name, onBlur, event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function () {
      _this.setState({
        focused: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBlur", function () {
      _this.setState({
        focused: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setHeight", function (element) {
      if (!element) return;
      var labelHeight = element.scrollHeight | 0;

      _this.setState({
        labelHeight: labelHeight
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleLabel", function () {
      _this.setState(function (prevState) {
        return {
          isLabelOpen: !prevState.isLabelOpen
        };
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScroll", function (direction) {
      try {
        if (_this.state.labelRef.current) {
          var scrollBox = _this.state.labelRef.current.childNodes[0];

          if (direction === 'UP') {
            scrollBox.scrollBy(0, -10);
          } else if (direction === 'DOWN') {
            scrollBox.scrollBy(0, 10);
          } else {
            var isScrolledToBottom = scrollBox.scrollTop >= scrollBox.scrollHeight - scrollBox.offsetHeight;

            if (_this.state.isScrolledToBottom !== isScrolledToBottom) {
              _this.setState({
                isScrolledToBottom: isScrolledToBottom
              });
            }
          }
        }
      } catch (_unused) {// Fail silently
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScrollUp", function () {
      _this.handleScroll('UP');
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScrollDown", function () {
      _this.handleScroll('DOWN');
    });

    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _classnames, _classnames2;

      var _this$props2 = this.props,
          bordered = _this$props2.bordered,
          bottomMargin = _this$props2.bottomMargin,
          children = _this$props2.children,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          hint = _this$props2.hint,
          label = _this$props2.label,
          name = _this$props2.name,
          tooltip = _this$props2.tooltip,
          topMargin = _this$props2.topMargin,
          value = _this$props2.value,
          clippingHeight = _this$props2.clippingHeight,
          isExpandable = _this$props2.isExpandable,
          renderExpandButton = _this$props2.renderExpandButton,
          isScrollable = _this$props2.isScrollable,
          hasScrollButtons = _this$props2.hasScrollButtons;
      var _this$state = this.state,
          focused = _this$state.focused,
          labelHeight = _this$state.labelHeight,
          isLabelOpen = _this$state.isLabelOpen,
          labelRef = _this$state.labelRef,
          isScrolledToBottom = _this$state.isScrolledToBottom;
      var className = classnames((_classnames = {}, _defineProperty(_classnames, classes.container, true), _defineProperty(_classnames, classes.container__topMargin, topMargin), _defineProperty(_classnames, classes.container__bottomMargin, bottomMargin), _defineProperty(_classnames, "errorMessage", error), _classnames), classNameProp);
      var isClipped = (isExpandable || isScrollable) && labelHeight > clippingHeight && !isLabelOpen;
      return React.createElement("div", {
        className: className
      }, React.createElement("div", {
        className: classes.wrapper
      }, React.createElement("label", {
        htmlFor: name,
        className: classnames(classes.label, disabled && classes.label__disabled)
      }, React.createElement("div", {
        className: classnames((_classnames2 = {}, _defineProperty(_classnames2, classes.checkbox, true), _defineProperty(_classnames2, classes.checkbox__bordered, bordered), _defineProperty(_classnames2, classes.checkbox__focused, focused), _defineProperty(_classnames2, classes.checkbox__error, error), _defineProperty(_classnames2, classes.checkbox__checked, value), _classnames2))
      }, value && React.createElement(IconCheck, {
        className: classes.icon
      })), React.createElement("input", {
        checked: value,
        className: classes.input,
        disabled: disabled,
        id: name,
        key: "input",
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        type: "checkbox"
      }), React.createElement("div", {
        ref: labelRef
      }, React.createElement(AnimateHeight, {
        className: classnames([isClipped && !isScrolledToBottom && classes.fade, isScrollable && classes.scrollable, hasScrollButtons && classes.noScrollbar]),
        duration: 500,
        height: isClipped ? clippingHeight : 'auto',
        onScroll: isScrollable && this.handleScroll
      }, React.createElement("span", {
        ref: this.setHeight,
        className: classes.checkboxLabel
      }, children || label))), React.createElement(Tooltip, {
        tooltip: tooltip,
        size: 18
      })), isScrollable && hasScrollButtons && labelHeight > clippingHeight && React.createElement("div", {
        className: classes.scrollButtons
      }, React.createElement("button", {
        type: "button",
        className: classes.scrollButton,
        onClick: this.handleScrollUp
      }, React.createElement(IconChevron, {
        className: classnames([classes.scrollChevron, classes.up])
      })), React.createElement("button", {
        type: "button",
        className: classes.scrollButton,
        onClick: this.handleScrollDown
      }, React.createElement(IconChevron, {
        className: classes.scrollChevron
      })))), React.createElement(FormError, {
        noMargin: true
      }, error), React.createElement(FormHint, null, hint), labelHeight > clippingHeight && isExpandable && React.createElement("button", {
        onClick: this.toggleLabel,
        className: classes.button,
        type: "button"
      }, renderExpandButton ? renderExpandButton(isClipped) : React.createElement(IconChevron, {
        className: "".concat(classes.chevron, " ").concat(isClipped ? '' : classes.chevronOpen)
      })));
    }
  }]);

  return Checkbox;
}(React.PureComponent);

_defineProperty(Checkbox, "styleRoot", 'Checkbox');

_defineProperty(Checkbox, "defaultProps", {
  bottomMargin: true,
  topMargin: true,
  value: false,
  isExpandable: false,
  clippingHeight: 60
});

export default injectStyles(styles)(Checkbox);